import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { Dialog, Input } from '@rneui/themed';

const EnterNumberDialog = ({ title, visible, onOkPress }) => {
  const [number, setNumber] = useState();
  return (
    <Dialog
      overlayStyle={styles.overlayStyle}
      isVisible={visible}
      onBackdropPress={onOkPress}
    >
      <Dialog.Title title={title} />
      <Input
        placeholderTextColor="lightgrey"
        placeholder="Skriv här"
        keyboardType="numeric"
        onChangeText={setNumber}
      />
      <Dialog.Actions>
        <Dialog.Button title="OK" onPress={() => onOkPress(number)} />
      </Dialog.Actions>
    </Dialog>
  );
};

const styles = StyleSheet.create({
  overlayStyle: {
    backgroundColor: 'white',
  },
});

export default EnterNumberDialog;
